export default {
    selectIcon: {
        top: 'calc(50% - 12px)',
    },
};
